import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WellHeaderInfoService } from 'app/modules/well-header-information/services/well-header-info.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceValidator } from 'app/core/shared/helper/form.helper';
import module from "app/modules/well-header-information/well-header-information.module";

@Component({
  selector: 'app-edit-well-modal',
  templateUrl: './edit-well-modal.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: module,
  styleUrls: ['./edit-well-modal.component.scss']
})
export class EditWellModalComponent {
  public wellForm: FormGroup
  public isSuccess: boolean = false
  public isLoading: boolean = false

  constructor(
    public dialogRef: MatDialogRef<EditWellModalComponent>,
    @Inject(MAT_DIALOG_DATA) public wellData: any,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private wellHeaderInfoService: WellHeaderInfoService) { }

  ngOnInit() {
    this.wellForm = this.initializeForm()

    this.wellForm.get('wellShortName')?.valueChanges.subscribe(value => {
      if (value && value !== value.toUpperCase()) {
        this.wellForm.get('wellShortName')?.setValue(value.toUpperCase(), { emitEvent: false });
      }
    });

    this.wellForm.setValue({
      id: this.wellData.wellId,
      platformId: this.wellData.platformId,
      wellShortName: this.wellData.name,
      wellLongName: this.wellData.longName,
      wellStatus: this.wellData.status,
      latitude: this.wellData.latitude,
      longitude: this.wellData.longitude,
      uwi: this.wellData.uWI,
      slotNumber: this.wellData.slotNumber,
      remarks: this.wellData.status,
    })
  }

  initializeForm() {
    return this.fb.group({
      id: this.wellData.wellId,
      platformId: this.wellData.platformId,
      wellShortName: ['', [Validators.required, noWhitespaceValidator()]],
      wellLongName: ['', [Validators.required, noWhitespaceValidator()]],
      wellStatus: '',
      latitude: 0,
      longitude: 0,
      uwi: '',
      slotNumber: '',
      remarks: '',
    })
  }

  updateWells() {
    this.isLoading = true

    this.wellHeaderInfoService.updateWells(this.wellForm.value).subscribe(
      {
        next: (res) => {
          if (res.isSuccess) {
            this.isSuccess = true
            this.closeDialog()
          }
          this.isLoading = false
        },
        error: (err) => this.isLoading = false
      })
  }

  closeDialog(): void {
    this.dialogRef.close(this.isSuccess);
  }

  get wellLongName() {
    return this.wellForm.get('wellLongName');
  }

  get wellShortName() {
    return this.wellForm.get('wellShortName');
  }
}
